import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { TIERS } from '../../shared/preview-url'

export interface TierSwitcherProps {
  tier: number
  onChange: (tier: number) => void
}

export default function TierSwitcher({ tier, onChange }: TierSwitcherProps) {
  const { formatMessage } = useIntl()

  return (
    <ToggleButtonGroup
      exclusive={true}
      size="small"
      value={tier}
      aria-label={formatMessage({ id: 'avatarStudio.preview.tierAria' })}
      onChange={(_e, next: number | null) => {
        if (next !== null) {
          onChange(next)
        }
      }}
    >
      {TIERS.map((t) => (
        <ToggleButton key={t} value={t}>
          {formatMessage({ id: 'avatarStudio.option.tierBadge' }, { tier: t })}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
